export default __webpack_public_path__ + "static/media/key-feature-edit-history.631034fc.mp4";